import React,{useState,useEffect,useRef}from 'react'
import { Modal,Form,Input, App} from 'antd';
import Icon from '../../../cpn/Icon';
import {  usePingtaiTypeUpdateSaveMutation } from '../../../store/DianShangYeWuApi';
function ShopEdit(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const onCreateEdit = (values) => {
        // console.log('Received values of form: ', values);
        setOpen(false);
    };
    const [info,setInfo] = useState({
        dspt_name:props.dspt_name,
        dspt_qy_id:props.qy_id,
        dspt_qy_name:props.qy_name,
        dspt_uid:props.yh_id,
        dspt_uname:props.yh_name,
        dspt_id:props.dspt_id,
    }); 
    const editForm = useRef()
    useEffect(() => {
        if(editForm.current){   
            editForm.current.setFieldsValue({
                dspt_name:props.dspt_name,
            })   
        }
    },[open ,props.dspt_name])
    const [goodsEdit] = usePingtaiTypeUpdateSaveMutation()    
    return (
        <>
            <Icon type='edit' onClick={() => {setOpen(true)}} />
            <Modal
                width={1000}                        
                open={open}
                title='修改店铺'
                okText="保存"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {                    
                    form
                        .validateFields()
                        .then((values) => {
                            goodsEdit(info).then((res) => {
                                // console.log(res);
                                if (res.data.Status === 'success') {
                                    message.success('修改成功')   
                                    setOpen(false);
                                    form.resetFields();
                                    onCreateEdit(values);
                                }
                                if (res.data.Status === 'fail') {
                                    message.error('修改失败：'+res.data.Message)
                                }
                            })
                        })
                        .catch((info) => {
                            // console.log('Validate Failed:', info);
                        });
                }}
            >
                <Form
                    form={form}
                    layout="horizonal"
                    name={`form_client_edit_${props.yh_id}`}
                    initialValues={{modifier: 'public',}}
                    labelCol={{ span: 3 }}
                    ref={editForm}
                >                    
                    <Form.Item name="dspt_name" wrapperCol={{span:4}} required label='名称'>                        
                        <Input onChange={(e) => {
                            setInfo(prevState=>({...prevState,dspt_name:e.target.value}))
                        }}/>
                    </Form.Item>                                           
                </Form>
            </Modal>
        </>
    )
}

export default ShopEdit